'use strict';

exports.__esModule = true;

var _appsmartIdentity = require('./appsmart-identity');

var filters = {
    ALL: 'all',
    MARKETPLACE: 'marketplace'
};

// 'AppSmart' requests have extra filter(s)
if ((0, _appsmartIdentity.isAppSmart)()) {
    filters.PROVIDERS = 'providers';
    filters.ADVISORS = 'advisors';
}

exports.default = filters;